module.exports = __webpack_public_path__ + "src/modules/home/training/images/1708.png";


//////////////////
// WEBPACK FOOTER
// ./src/modules/home/training/images/1708.png
// module id = 791
// module chunks = 0